function SpacePirates() {

    return (<div>
        This is one of the cryptography challenges from the HTB Uni CTF Qualifiers 2021.
    </div>);
}

export default SpacePirates;